import { Injectable } from '@angular/core';

import { HttpService } from '../http.service';
import { Observable } from '../util/rxjs';

export interface FeedbackBarError {
  message: string;
  params: { [key: string]: any };
}

@Injectable()
export class FeedbackBarService {
  errors$: Observable<FeedbackBarError>;

  constructor(http: HttpService) {
    this.errors$ = http.errors$.map(error => ({
      message: error.LocalizationKey || error.Message,
      params: error.LocalizationParams || {},
    } as FeedbackBarError));
  }
}
